module.exports = __webpack_public_path__ + "static/img/pice3.1f7f9b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solutions/pice3.png
// module id = 7byQ
// module chunks = 0